var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralBuildingIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 36.428,
    viewBox: "0 0 34 36.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12435",
    "data-name": "Group 12435",
    transform: "translate(1523.924 -540.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12414",
    "data-name": "Group 12414",
    transform: "translate(-1516.638 545.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11097",
    "data-name": "Path 11097",
    d: "M-1495.5,577.925h-1.619V547.973h-16.19v29.952h-1.619V547.164a.81.81,0,0,1,.809-.81h17.81a.81.81,0,0,1,.81.81Z",
    transform: "translate(1514.924 -546.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12415",
    "data-name": "Group 12415",
    transform: "translate(-1514.21 540.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11098",
    "data-name": "Path 11098",
    d: "M-1497.353,546.021h-1.619v-4.048H-1510.3v4.048h-1.619v-4.857a.81.81,0,0,1,.809-.81h12.952a.81.81,0,0,1,.81.81Z",
    transform: "translate(1511.924 -540.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12416",
    "data-name": "Group 12416",
    transform: "translate(-1510.162 571.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11099",
    "data-name": "Path 11099",
    d: "M-1500.448,584.211h-1.619v-3.238h-3.238v3.238h-1.619v-4.048a.81.81,0,0,1,.81-.81h4.857a.81.81,0,0,1,.81.81Z",
    transform: "translate(1506.924 -579.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12417",
    "data-name": "Group 12417",
    transform: "translate(-1512.591 558.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11100",
    "data-name": "Path 11100",
    d: "M-1505.067,565.592h-1.619v-1.619h-1.619v1.619h-1.619v-2.429a.81.81,0,0,1,.809-.81h3.238a.81.81,0,0,1,.809.81Z",
    transform: "translate(1509.924 -562.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12418",
    "data-name": "Group 12418",
    transform: "translate(-1512.591 564.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11101",
    "data-name": "Path 11101",
    d: "M-1505.067,573.592h-1.619v-1.619h-1.619v1.619h-1.619v-2.429a.81.81,0,0,1,.809-.81h3.238a.81.81,0,0,1,.809.81Z",
    transform: "translate(1509.924 -570.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12419",
    "data-name": "Group 12419",
    transform: "translate(-1506.115 558.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11102",
    "data-name": "Path 11102",
    d: "M-1497.067,565.592h-1.619v-1.619h-1.619v1.619h-1.619v-2.429a.81.81,0,0,1,.81-.81h3.238a.81.81,0,0,1,.81.81Z",
    transform: "translate(1501.924 -562.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12420",
    "data-name": "Group 12420",
    transform: "translate(-1512.591 551.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11103",
    "data-name": "Path 11103",
    d: "M-1505.067,557.592h-1.619v-1.619h-1.619v1.619h-1.619v-2.429a.81.81,0,0,1,.809-.81h3.238a.81.81,0,0,1,.809.81Z",
    transform: "translate(1509.924 -554.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12421",
    "data-name": "Group 12421",
    transform: "translate(-1506.115 551.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11104",
    "data-name": "Path 11104",
    d: "M-1497.067,557.592h-1.619v-1.619h-1.619v1.619h-1.619v-2.429a.81.81,0,0,1,.81-.81h3.238a.81.81,0,0,1,.81.81Z",
    transform: "translate(1501.924 -554.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12422",
    "data-name": "Group 12422",
    transform: "translate(-1506.115 564.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11105",
    "data-name": "Path 11105",
    d: "M-1497.067,573.592h-1.619v-1.619h-1.619v1.619h-1.619v-2.429a.81.81,0,0,1,.81-.81h3.238a.81.81,0,0,1,.81.81Z",
    transform: "translate(1501.924 -570.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12423",
    "data-name": "Group 12423",
    transform: "translate(-1495.591 563.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3569",
    "data-name": "Rectangle 3569",
    width: 3,
    height: 2,
    transform: "translate(-0.333 0.047)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12424",
    "data-name": "Group 12424",
    transform: "translate(-1495.591 566.259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3570",
    "data-name": "Rectangle 3570",
    width: 3,
    height: 2,
    transform: "translate(-0.333 -0.191)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12425",
    "data-name": "Group 12425",
    transform: "translate(-1495.591 569.497)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3571",
    "data-name": "Rectangle 3571",
    width: 3,
    height: 2,
    transform: "translate(-0.333 -0.429)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12426",
    "data-name": "Group 12426",
    transform: "translate(-1495.591 572.735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3572",
    "data-name": "Rectangle 3572",
    width: 3,
    height: 1,
    transform: "translate(-0.333 0.332)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12427",
    "data-name": "Group 12427",
    transform: "translate(-1498.019 559.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11106",
    "data-name": "Path 11106",
    d: "M-1483.829,581.354h-1.619V565.973h-6.476v-1.619h7.286a.81.81,0,0,1,.81.81Z",
    transform: "translate(1491.924 -564.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12428",
    "data-name": "Group 12428",
    transform: "translate(-1498.019 555.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11107",
    "data-name": "Path 11107",
    d: "M-1486.257,564.211h-1.619v-3.238h-4.048v-1.619h4.857a.81.81,0,0,1,.81.81Z",
    transform: "translate(1491.924 -559.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12429",
    "data-name": "Group 12429",
    transform: "translate(-1520.686 563.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3573",
    "data-name": "Rectangle 3573",
    width: 3,
    height: 2,
    transform: "translate(-0.238 0.047)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12430",
    "data-name": "Group 12430",
    transform: "translate(-1520.686 566.259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3574",
    "data-name": "Rectangle 3574",
    width: 3,
    height: 2,
    transform: "translate(-0.238 -0.191)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12431",
    "data-name": "Group 12431",
    transform: "translate(-1520.686 569.497)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3575",
    "data-name": "Rectangle 3575",
    width: 3,
    height: 2,
    transform: "translate(-0.238 -0.429)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12432",
    "data-name": "Group 12432",
    transform: "translate(-1520.686 572.735)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3576",
    "data-name": "Rectangle 3576",
    width: 3,
    height: 1,
    transform: "translate(-0.238 0.332)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12433",
    "data-name": "Group 12433",
    transform: "translate(-1523.924 559.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11108",
    "data-name": "Path 11108",
    d: "M-1522.3,581.354h-1.619v-16.19a.81.81,0,0,1,.809-.81h7.286v1.619h-6.476Z",
    transform: "translate(1523.924 -564.354)",
    fill: "#010101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12434",
    "data-name": "Group 12434",
    transform: "translate(-1521.495 555.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11109",
    "data-name": "Path 11109",
    d: "M-1519.3,564.211h-1.619v-4.048a.81.81,0,0,1,.81-.81h4.857v1.619h-4.047Z",
    transform: "translate(1520.924 -559.354)",
    fill: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralBuildingIcon);
export default __webpack_public_path__ + "static/media/general_building_icon.505d9511600f46bf99c26181139aa849.svg";
export { ForwardRef as ReactComponent };